var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-143 -324) translate(143 324)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#463C32",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.186 45.313L34.314 31.44c2.687-3.319 4.305-7.537 4.305-12.13C38.62 8.663 29.956 0 19.31 0 8.664 0 0 8.663 0 19.31c0 10.647 8.663 19.31 19.31 19.31 4.593 0 8.81-1.618 12.13-4.306l13.872 13.873c.397.396.917.596 1.438.596.52 0 1.04-.2 1.437-.596.794-.795.794-2.08 0-2.874zM19.31 34.554c-8.407 0-15.245-6.837-15.245-15.244S10.903 4.065 19.31 4.065c8.406 0 15.244 6.838 15.244 15.245S27.716 34.554 19.31 34.554z",
    transform: "translate(32.522 31.565)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.117 21.794c.22.222.51.332.8.332.29 0 .58-.11.801-.332l.506-.505.506.505c.221.222.511.332.8.332.29 0 .58-.11.802-.332.442-.442.442-1.159 0-1.601l-.506-.506.506-.506c.442-.442.442-1.16 0-1.602-.443-.442-1.16-.442-1.602 0l-.506.506-.506-.506c-.442-.442-1.159-.442-1.601 0-.442.443-.442 1.16 0 1.602l.506.506-.506.506c-.442.442-.442 1.16 0 1.601zM25.42 21.794c.22.222.51.332.8.332.29 0 .58-.11.801-.332l.506-.505.506.505c.221.222.511.332.801.332.29 0 .58-.11.8-.332.443-.442.443-1.159 0-1.601l-.505-.506.506-.506c.442-.442.442-1.16 0-1.602-.443-.442-1.16-.442-1.602 0l-.506.506-.506-.506c-.442-.442-1.159-.442-1.601 0-.442.443-.442 1.16 0 1.602l.506.506-.506.506c-.442.442-.442 1.16 0 1.601zM24.274 26.511c.276-.594.048-1.314-.51-1.609-3.052-1.61-6.147-1.61-9.199 0-.558.295-.786 1.015-.51 1.61.198.422.597.667 1.013.667.168 0 .34-.04.5-.125 2.42-1.277 4.773-1.277 7.193 0 .559.294 1.236.051 1.513-.543z",
    transform: "translate(32.522 31.565)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.f71a9859.svg";
export { ForwardRef as ReactComponent };